import { useState, useEffect } from "react";
import { Footer } from "./containers/footer";
import { UploadForm } from "./containers/upload";
import { Content } from "./containers/home/content";
import { NewImage } from "./containers/home/newImage";
import { Loader } from "./components/loader";
import { generateRandomString } from "../helpers/string";

const fileName = generateRandomString("letters", 8).toLowerCase() + ".jpg";

export default function HomePage() {
    const [loading, setLoading] = useState(true);
    const [processed, setProcessed] = useState(false);
    const [url, setUrl] = useState("");

    useEffect(() => {
        setTimeout(() => {
            setLoading(false);
        }, 2000);
    }, [setLoading, loading]);

    return (
        <div className=" bg-center bg-cover font-manjari">
            {!loading ? (
                <div className="flex flex-col h-screen">
                    <div className="flex items-stretch px-10 p-5 max-sm:justify-center">
                        <a href="/" className="flex flex-row">
                            <img
                                className="w-6 h-6"
                                src="/logo.png"
                                alt="logo"
                            />
                            <h1 className="mx-4  text-2xl font-extrabold text-gray-800 dark:text-white md:text-2xl lg:text-2xl">
                                BEAM-AI
                            </h1>
                        </a>
                    </div>
                    <div className="flex md:h-full md:items-center">
                        <div className="flex justify-center px-10 gap-10 w-full">
                            {processed ? (
                                <NewImage url={url} fileName={fileName} />
                            ) : (
                                <div className="flex items-center px-10 gap-5 w-full max-sm:flex-col-reverse max-sm:w-screen max-sm:px-2">
                                    <UploadForm
                                        setProcessed={setProcessed}
                                        setUrl={setUrl}
                                        setLoading={setLoading}
                                        fileName={fileName}
                                    />
                                    <Content />
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="">
                        <Footer />
                    </div>
                </div>
            ) : (
                <Loader />
            )}
        </div>
    );
}
